export const ModalGridContainer = () => ({
    overflow: "auto",
    zIndex: 10,
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
});

export const ModalGrid = () => ({
    position: "absolute",
    left: "49%",
    top: "45%",
    transform: "translate(-50%, -50%)",
    width: "28%",
    height: "auto",
    bgcolor: "background.paper",
    padding: "0rem 1rem 1rem 1.5rem",
    borderRadius: "0.1rem",
    marginLeft: "1.5rem",
    zIndex: 10,
});

export const ContentBoxHeader = () => ({
    display: "flex",
    flexDirection: "row",
    paddingTop: "2rem",
});

export const CreateBtn = () => ({
    height: "2.2rem",
    borderRadius: "1.5rem",
    textTransform: "none",
});

export const IconButtonStyles = () => ({
    display: "flex",
    justifyContent: "end",
   
});

export const TypographyStyles = () => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 0.3
});

export const IconStyle = () => ({
    right: -10
})
export const CheckboxStyle = () => ({
    display: "flex",
    flexDirection: "column"

})